import { createReducer } from '@ngrx/store';

/* state key */
export const featureKey = 'SettingsDataStore';

/* state interface */
export interface SettingsState {
  PROJECT_ID: string;
  apiBaseUrl: string;
  production: boolean;
  RAPIDER_AI_API_BASE_URL: string;
  DESCOPE_PROJECT_ID: string;
  STAGE: string;
  usernameType: string;
  isAuthenticationEnabled: boolean;
  paymentProvider: string;
  authenticateWithCredentials: boolean;
  authenticateWithDescope: boolean;
  adminDashboardLayoutId: string;
  adminModuleId: string;
  adminHomePageId: string;
  defaultModuleId: string;
  homePageId: string;
}

/* initial values */
export const initialState: SettingsState = {
  PROJECT_ID: '20197491-0906-4f36-8ce4-c5fa9d1e22d7',
  apiBaseUrl: 'https://20197491-0906-4f36-8ce4-c5fa9d1e22d7.api.rappider.com',
  production: false,
  RAPIDER_AI_API_BASE_URL: 'https://api.rapider.ai',
  DESCOPE_PROJECT_ID: null,
  STAGE: 'DEV',
  usernameType: 'email',
  isAuthenticationEnabled: true,
  paymentProvider: 'not-provided',
  authenticateWithCredentials: true,
  authenticateWithDescope: false,
  adminDashboardLayoutId: '954a1c6f-47a6-477f-b8a2-0050e5f30261',
  adminModuleId: 'ddf60c8c-482c-4aa6-a022-a0e01d9664c9',
  adminHomePageId: '23c9e224-dc2a-4448-81de-709adebb33fb',
  defaultModuleId: '236ed876-f804-4e99-888c-6a761c12385b',
  homePageId: '7aec9b1c-9abb-4389-91e9-72cdea3a527e',
};

export const reducer = createReducer(initialState);
